export default "mutation batchRemoveUserCourse($batchRemove: UserBatchRemoveCourseRequest) {\n  batchRemoveUserCourse(batchRemove: $batchRemove) \n}";